import { graphql, useStaticQuery } from 'gatsby';
import ImageCardList from 'molecules/ImageCardList/ImageCardList';
import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import { ImageCardProps } from 'src/app/molecules/ImageCard/ImageCard';
import { IStaticContentfulImages } from 'src/types/contentful';

const KnowUsBetterImageCards = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      reviews: contentfulAsset(contentful_id: { eq: "2W32ZEZRsiD41n1O9kGpx7" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      roadmap: contentfulAsset(contentful_id: { eq: "4XDvUHQfNHjKpX0qrWUnGd" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      moveToMighty: contentfulAsset(contentful_id: { eq: "3MoRl1ynoASEVuUNVKlGVl" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
    }
  `);

  const baseImageCardHeadingProps = {
    type: 'paragraph',
    size: 'lg',
    fontWeight: 'font-weight-semibold',
  };

  const baseImageCardSupportingTextProps = {
    type: 'paragraph',
    size: 'md',
    color: 'text-tertiary',
  };

  const imageCards = [
    {
      image: {
        image: images.reviews.gatsbyImageData,
        alt: 'Reviews',
      },
      title: {
        ...baseImageCardHeadingProps,
        text: 'Reviews',
      },
      supportingText: {
        ...baseImageCardSupportingTextProps,
        text: 'People love talking about us. We love giving them more and more to say.',
      },
      href: '/reviews',
    },
    {
      image: {
        image: images.roadmap.gatsbyImageData,
        alt: 'Roadmap',
      },
      title: {
        ...baseImageCardHeadingProps,
        text: 'Our Product Roadmap',
      },
      supportingText: {
        ...baseImageCardSupportingTextProps,
        text: 'We’re not just keeping up. We’re shaping what’s next.',
      },
      href: 'https://portal.productboard.com/wvvyyuvre1lgd6rcaw5mpdfz/tabs/9-in-development',
    },
    {
      image: {
        image: images.moveToMighty.gatsbyImageData,
        alt: 'Move to Mighty',
      },
      title: {
        ...baseImageCardHeadingProps,
        text: 'Move to Mighty',
      },
      supportingText: {
        ...baseImageCardSupportingTextProps,
        text: 'Can we roll out the red carpet for your members (and their payments)?',
      },
      href: '/migration',
    },
  ] as ImageCardProps[];

  return (
    <Stack
      direction='column'
      gap='spacing-5xl'
    >
      <Typography
        type='heading'
        size='lg'
        text='Get to know us better'
        fontWeight='font-weight-semibold'
      />
      <ImageCardList imageCards={imageCards} />
    </Stack>
  );
};
export default KnowUsBetterImageCards;
